var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "stat-list" },
    _vm._l(_vm.declaration, function (item, index) {
      return _c("li", { key: index }, [
        _c("h2", { staticClass: "no-margins" }, [_vm._v(_vm._s(item.total))]),
        _vm._v(" "),
        _c("small", [_vm._v(_vm._s(item.title))]),
        _vm._v(" "),
        _c("div", { staticClass: "stat-percent" }, [
          _vm._v(_vm._s(item.percent) + "% "),
          _c("i", { staticClass: "fa fa-level-down text-navy" }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "progress progress-mini" }, [
          _c("div", {
            staticClass: "progress-bar",
            style: { width: `${item.percent}%` },
          }),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }